import React from 'react';
import { useAppContext, useTranslator } from '@front-activerse/common-components';

const HowToActivateInfo: React.FC = () => {
  const { t } = useTranslator();

  const {
    images: { emailIcon, deliveryIcon, phoneIcon },
  } = useAppContext();

  return (
    <>
      <h3 className="title-large semi-bold text-center mb-xl">
        {t('app.thankUPage.howToActivateTheService')}
      </h3>
      <div className="d-flex align-items-start mb-xl">
        <img src={emailIcon} className="me-3" alt="" />
        <p className="text-text-variant-color mb-0">{t('app.thankUPage.step1')}</p>
      </div>
      <div className="d-flex align-items-start mb-xl">
        <img src={deliveryIcon} className="me-3" alt="" />
        <p className="text-text-variant-color mb-0">{t('app.thankUPage.step2')}</p>
      </div>
      <div className="d-flex align-items-start">
        <img src={phoneIcon} className="me-3" alt="" />
        <p className="text-text-variant-color mb-0">
          {t('app.thankUPage.step3.part1')}{' '}
          <a
            style={{ wordBreak: 'break-all' }}
            href={`${import.meta.env.VITE_REACT_APP_URL}/activation`}
          >
            {import.meta.env.VITE_REACT_APP_URL}/activation
          </a>{' '}
          {t('app.thankUPage.step3.part2')}
        </p>
      </div>
    </>
  );
};

export default HowToActivateInfo;
